import { Link } from "react-router-dom";
import PlatformNews1 from "../../assets/PlatformNews.svg";
import { useGetAllArticlesQuery } from "../../redux/Service/api";
// ... existing code ...
// ... existing code ...
function PlatformNews() {
  const { data, isLoading, isError } = useGetAllArticlesQuery(undefined);

  const allArticles = data?.data ?? [];

  return (
    <section className="bg-gray-50 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#180337] relative after:content-[''] after:absolute after:-bottom-4 after:right-0 after:w-2/3 after:h-1 after:bg-purple-600">
            اخبار المنصه
          </h2>
          {/* <button className="hidden md:inline-flex items-center text-purple-700 hover:text-purple-800 font-semibold transition-colors duration-200">
            عرض جميع الأخبار
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2 rtl:rotate-180"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </button> */}
        </div>

        <div className="grid gap-8">
          {isLoading || isError ? (
            <article className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-3">
                <div className="relative h-[300px] md:h-full">
                  <img
                    src={PlatformNews1}
                    alt="PlatformNews"
                    className="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent md:hidden"></div>
                </div>
                <div className="md:col-span-2 p-6 md:p-8 flex flex-col relative">
                  <div className="flex-grow">
                    <div className="flex items-center gap-4 mb-4">
                      <span className="px-3 py-1 text-xs font-semibold text-purple-700 bg-purple-50 rounded-full">
                        أخبار المنصة
                      </span>
                      <time className="text-sm text-gray-500">
                        22 مارس 2024
                      </time>
                    </div>
                    <h3 className="text-xl md:text-2xl font-bold text-gray-900 leading-tight mb-4">
                      فى اطار التعاون المشترك مع وزاره السياحه تم توقيع اتفاقيه
                      تقديم الخدمات لزوار المملكه خلال موسم الرياض
                    </h3>
                    <p className="text-gray-600 leading-relaxed line-clamp-3">
                      تفاصيل الخبر والمحتوى الإضافي يظهر هنا...
                    </p>
                  </div>
                  <div className="mt-6 flex items-center justify-between">
                    <button
                      type="button"
                      className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 focus:ring-4 focus:ring-purple-100 transition-all duration-200"
                    >
                      اقرأ المزيد
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 mr-2 rtl:rotate-180"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </article>
          ) : (
            allArticles?.map((article: any) => (
              <article
                key={article.id}
                className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 border border-gray-100"
              >
                <div className="grid grid-cols-1 md:grid-cols-3">
                  <div className="relative h-[300px] md:h-full">
                    <img
                      src={article.photo}
                      alt={article.title}
                      className="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent md:hidden"></div>
                  </div>
                  <div className="md:col-span-2 p-6 md:p-8 flex flex-col relative">
                    <div className="flex-grow">
                      <div className="flex items-center gap-4 mb-4">
                        <span className="px-3 py-1 text-xs font-semibold text-purple-700 bg-purple-50 rounded-full">
                          {article.title}
                        </span>
                        <time className="text-sm text-gray-500">
                          {article.date}
                        </time>
                      </div>
                      <h3 className="text-xl md:text-2xl font-bold text-gray-900 leading-tight mb-4">
                        {article.description}
                      </h3>
                      <p className="text-gray-600 leading-relaxed line-clamp-3">
                        {article.content}
                      </p>
                    </div>
                    <div className="mt-6 flex items-center justify-between">
                      <Link
                        to={`/articleDetails/${article.id}`}
                        className="inline-flex items-center justify-center px-6 py-2.5 text-sm font-medium text-white bg-purple-600 rounded-lg hover:bg-purple-700 focus:ring-4 focus:ring-purple-100 transition-all duration-200"
                      >
                        اقرأ المزيد
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-4 mr-2 rtl:rotate-180"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </Link>
                    </div>
                  </div>
                </div>
              </article>
            ))
          )}
        </div>
      </div>
    </section>
  );
}

export default PlatformNews;
